import {Graphics, Container} from 'pixi.js';
import {ObjectBuilder, RichText} from '@gongxigames/framework/core';
import {StickyComponent, StickyRichLabelData} from '@gongxigames/framework/slot/modules/watermark';

export class StickyRichTextLabelComponent extends StickyComponent {
    protected _label!: RichText;
    protected background?: Graphics;

    protected initGraphic(data: StickyRichLabelData, objectBuilder: ObjectBuilder, rootContainer: Container): void {
        super.initGraphic(data, objectBuilder, rootContainer);

        this._label = objectBuilder.buildRichText(data);
        this._sourceContainer.getChildByName<Container>(data.labelContainerName).addChild(this._label);

        data.hasBackground && this.addLabelBackground();
    }

    public updateText(value: string): void {
        this._label.updateText({
            values: {
                value
            }
        });
        this.background && this.resizeLabelBackground();
        this.changeLabelPositionDependingOnTextAlign();
    }

    public updateStyle(style: string): void {
        this._label.updateText({style});
    }

    public get label(): RichText {
        return this._label;
    }

    protected addLabelBackground(): void {
        const [width, height] = this.getBackgroundSize();
        const graphics = new Graphics();

        graphics.beginFill(0x000000, 0.6);
        graphics.drawRect(0, 0, width, height);
        this.sourceContainer?.addChildAt(graphics, 0);
        this.background = graphics;
    }

    protected changeLabelPositionDependingOnTextAlign(): void {
        if (this.background) {
            const [width] = this.getBackgroundSize();
            const align = this._label.getStyles().align;

            switch (align) {
                case 'center':
                    this.background.x = -width / 2;
                    break;
                case 'right':
                    this.background.x = -width;
                    break;
                default:
                    this.background.x = 0;
                    break;
            }
        }
    }

    protected resizeLabelBackground(): void {
        if (this.background) {
            const [width, height] = this.getBackgroundSize();

            this.background.width = width;
            this.background.height = height;
        }
    }

    protected getBackgroundSize(): number[] {
        const bgOffset = 8;

        const width = (this.label?.width || 1) + bgOffset * 2;
        const height = (this.label?.height || 1) + bgOffset * 2;

        return [width, height];
    }
}
